<template>
  <div class="callout" :class="{ 'callout-warning': variant === 'warning' }">
    <slot />
  </div>
</template>

<script>
export default {
  name: "CalloutBox",
  props: {
    variant: {
      type: String,
      default: "default",
      validator: (v) => ["default", "warning"].includes(v),
    },
  },
};
</script>
